export default {
  methods: {
    // email后缀搜索
    handleSelect(val) {
      this.formData[this.item.id] = val
    },
    querySearch(queryString, cb) {
      let emailList = [
        '@gmail.com',
        '@yahoo.com',
        '@msn.com',
        '@hotmail.com',
        '@aol.com',
        '@ask.com',
        '@live.com',
        '@qq.com',
        '@0355.net',
        '@163.com',
        '@163.net',
        '@263.net',
        '@3721.net',
        '@yeah.net',
        '@googlemail.com',
        '@mail.com',
        '@hotmail.com',
        '@msn.com',
        '@yahoo.com',
        '@gmail.com',
        '@aim.com',
        '@aol.com',
        '@mail.com',
        '@walla.com',
        '@inbox.com',
        '@126.com',
        '@163.com',
        '@sina.com',
        '@21cn.com',
        '@sohu.com',
        '@yahoo.com.cn',
        '@tom.com',
        '@etang.com',
        '@eyou.com',
        '@56.com',
        '@x.cn',
        '@chinaren.com',
        '@sogou.com',
        '@citiz.com'
      ]
      let results = []
      let quertList = []
      emailList.map(e => {
        quertList.push(queryString.split('@')[0] + e)
      })
      results = queryString ? quertList.filter(this.createFilter(queryString)) : quertList
      cb(results)
    },
    createFilter(queryString) {
      return (email) => {
        return (email.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    }
  }
}